import React from 'react';
import { UncontrolledAlert } from 'reactstrap';
export default {
  Error,
};
function Error(props) {
  if (!props.text) return <></>;
  return (
    <UncontrolledAlert color="danger" fade={false}>
      {props.hasIcon ? (
        <i
          className="md-icon"
          style={{ verticalAlign: 'text-bottom', marginRight: 10 }}
        >
          error
        </i>
      ) : null}
      <span>{props.text}</span>
    </UncontrolledAlert>
  );
}
